import React from 'react';
import { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import {
    Highlight,
    HighlightList,
    StyledHighlights,
    HighlightPosition,
    HighligthLink,
} from './highlights.styles';
import OpenModal from '../../../VideoModal/OpenModal';

export const HighLights = ({ highlights, videoId, videoUrl }) => {
    return highlights?.length ? (
        <StyledHighlights aria-label="Navigera mellan kapitel i videon.">
            <HighlightList>
                {highlights.map((highlight) => (
                    <Highlight key={highlight.slug}>
                        <HighlightPosition size={SIZE.LARGE}>{highlight.positionFormatted}</HighlightPosition>
                        <OpenModal
                            videoId={videoId}
                            videoUrl={videoUrl}
                            position={highlight.positionInSeconds}
                            extraQuery={{ highlight: highlight.slug }}
                        >
                            {(onClick) => <HighligthLink onClick={onClick}>{highlight.name}</HighligthLink>}
                        </OpenModal>
                    </Highlight>
                ))}
            </HighlightList>
        </StyledHighlights>
    ) : null;
};

export default HighLights;
